<!-- Polls version.json every 5 minutes to detect if a new app version is available.-->
<!-- Shows a banner to the user instead of forcing a reload.-->
<template>
  <v-alert
      transition="slide-y-transition"
      v-if="showUpdateBanner"
      type="info"
      dense
      elevation="3"
      style="border-radius: 0"
  >
    <span>A new version of this app is available. Please refresh to prevent undesired behavior.</span>
    <v-btn class="ml-3" small color="white" outlined elevation="0" @click="refreshApp">
      Refresh
    </v-btn>
  </v-alert>
</template>

<script>
export default {
  name: 'NewVersionBanner',
  data() {
    return {
      pollingInterval: null,
      currentVersion: null,
      showUpdateBanner: false
    };
  },
  created() {
    this.startVersionPolling();
  },
  beforeDestroy() {
    this.clearPollingInterval();
  },
  methods: {
    async startVersionPolling() {
      try{
        const res = await fetch(`/version.json?ts=${Date.now()}`, { cache: 'no-store' });
        const { version } = await res.json();
        this.currentVersion = version;

        const POLL_INTERVAL = 5 * 60 * 1000; // every 5 minutes
        this.pollingInterval = setInterval(this.checkVersion, POLL_INTERVAL);
      }catch (e) {
        this.clearPollingInterval();
        console.warn('Version check failed during startup', e);
      }
    },
    async checkVersion() {
      try {
        const res = await fetch(`/version.json?ts=${Date.now()}`, {cache: 'no-store'});
        if (!res.ok) return;

        const {version} = await res.json();

        if (this.currentVersion && version !== this.currentVersion) {
          this.showUpdateBanner = true;
          this.clearPollingInterval();
        }
      } catch (err) {
        this.clearPollingInterval();
        console.warn('Version check failed during polling', err);
      }
    },
    refreshApp() {
      window.location.reload(true);
    },
    clearPollingInterval() {
      if(this.pollingInterval){
        clearInterval(this.pollingInterval);
      }
    }
  }
};
</script>
